import styled from 'styled-components';
import { rowAnimantion } from '../../../../styles/keyframes';
import { colors } from '../../../../styles/colors';

export const PrioritizedItemsTable = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1 1;
    overflow: hidden;
`;

export const Table = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1 1;
    width: 100%;
    min-height: 500px;
    border-radius: 10px 10px 0 0;
    box-sizing: border-box;
    font-size: calc(10.25px + 0.12vw) !important;
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    
    p{
        font-size: inherit;
    }
    .header{
        display:flex;

        box-sizing:border-box;

        height: 32px;
        
        font-weight: bold;  
        text-align: left;
        background: ${colors.greenDarkViveo};
        
        p{
            color: ${colors.white};
        }

        img{
            margin-left: 6.4px;   
        }
    }

    .body{
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        box-sizing:border-box;
        height: auto;
        
        .sk-circle{
            padding: 20px 0;
        }
    }
`;

interface IRow {
    stock?: boolean;
}

export const Row = styled.div<IRow>` 
    display: flex;
    width: 100%;
    box-sizing:border-box;    

    &:first-child{
        background-color:${props => props.stock ? '#FFE3E3' : '#D0DEE1'} !important;
    }

    .icon{
        transition: all 1s ease-in;
        img{
            display: none;
        }
    }
`;

interface ITRow {
    index?: number;
    stock?: boolean;
    className?: string;
}

export const TRow = styled.div<ITRow>`
    display: flex;
    width: 100%;
    box-sizing:border-box;
    animation: ${rowAnimantion} 1s ease-out;
    position: relative;
    font-weight: ${props => props.index === 0 && 'bold'};
    
    &.rowColor{
        
        img {
            cursor: pointer;
        }
        
        p {
            color: ${props => !props.stock && '#DE2248'}; 
        }
    }
    `;

interface ICellProps {
    isAutomatic?: boolean;
    className: string;
    key?: number;
}

export const Cell = styled.div<ICellProps>`    
    flex: 1 0;
    display: flex;
    padding: 0 12.8px;
    align-items: center;
    box-sizing:border-box;
    height: ${({isAutomatic}) => isAutomatic ? '80px !important' : '67px !important'};

    p {
        width:100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;   
    }

    &.header-height {
        height: 32px !important;
        background: ${colors.greenDarkViveo};
    }

    &.icon{
        flex: 1 1;
        justify-content: center;
        min-width: 25px;
        max-width: 25px;

        img{
            width: 15px;
            max-width: 15px !important;
            margin: 2px 5px 0 0;
        }
    }

    &.sequenceNumber {
        flex: 1 1;
        justify-content: center;
        min-width: 70px;
        max-width: 70px;
    }

    &.manufacturer{
        min-width: 170px;
        max-width: 170px;
    }

    &.supplierProductcode{
        min-width: 110px;
        max-width: 110px;
    }

    &.description {
        min-width: 315px;
    }

    &.medicineType {
        max-width: 180px;
        display: flex;
        justify-content: center;
    }

    &.unit, &.subUnit {
        min-width: 80px;
        max-width: 80px;
        justify-content: center;
    }

    &.conversionFactor{
        min-width: 150px;
        max-width: 150px;

        input {
            height: 26px;
        }
    }

    &.subunidValue{
        min-width: 120px;
        max-width: 120px;
    }

    &.actionsIcons{
        min-width: 110px;
        max-width: 110px;

        .itemStock{
            margin-left: 8px;
            img{
                max-width: initial;
            }
        }

        .deleteIcon{
            height: 16px;
            img{
                cursor: pointer;
            }
        }

        .iconsDownloadSheet {
            .sk-circle {
              padding: 0 !important;
            }
            img {
              cursor: pointer;
            }
        }

        .downloadLoader{
            margin-left: 5px;
            margin-right: 5px;
        }

        .sk-circle {
            padding: 0;
        }
    }

    &.medicineType {
        min-width: 150px;
        max-width: 150px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
`;
